import { ICatalogItem as CommerceSDKICatalogItem } from './types/catalogQuery'
import { PRODUCTS_PAGE_SIZE } from './constants'
import type { ICatalogItem, ICategory, ICategoryPagination } from './types'
import { sanitizeSlug } from './sanitize'

// cinnamon's union also admits `ICategoryNavigation[]`. That type belongs to
// category navigation, which is out of scope for this slice, so it was not
// ported — see docs/NOT_PORTED.md.
export const resolveSlugs = (
  categories: ICatalogItem[] | ICategory[] = [],
) => {
  const slugList = categories.map((cat) => cat?.slug || '')

  return categories.map((category, index) => {
    const otherSlugs = slugList.filter((_, i) => i !== index)
    let { slug = '' } = category
    let counter = 1

    while (otherSlugs.includes(slug)) {
      slug = `${slug}-${counter}`
      counter += 1
    }
    slugList[index] = slug

    return {
      ...category,
      slug,
    }
  })
}

export const filterCategoriesForMenu = (
  categories: CommerceSDKICatalogItem[] = [],
): CommerceSDKICatalogItem[] => {
  return categories.filter((category) => !category.parentId)
}

export const setCatalogPagination = (
  categories: ICatalogItem[] = [],
  paginationSize?: number,
): Record<string, ICategoryPagination> => {
  const pageSize = paginationSize || PRODUCTS_PAGE_SIZE
  const result: { [category: string]: ICategoryPagination } = {}

  categories.forEach(({ category, slug = '', productsPrices }) => {
    const newSlug = slug || sanitizeSlug(category || '')
    result[newSlug] = {
      pageNumber: Math.ceil((productsPrices?.length || 0) / pageSize),
      pageSize,
      hasMore:
        (productsPrices?.length || 0) === 0 ||
        (productsPrices?.length || 0) % pageSize === 0,
    }
  })

  return result
}

export const setCatalogData = (
  categories: ICatalogItem[] = [],
): ICatalogItem[] => {
  const categoryList = categories.map((cat) => ({
    ...cat,
    slug: cat.slug || sanitizeSlug(cat.category || ''),
  }))

  return resolveSlugs(categoryList) as ICatalogItem[]
}
